{
  "company": {
    "name": "Grupo Reflex",
    "description": "Transformamos el futuro con innovación. Convertimos ideas en proyectos funcionales con IA, creatividad y pasión.",
    "philosophy": [
      "No es como se ve... ¡Es como se siente! - Creamos experiencias que trascienden lo visual y conectan emocionalmente",
      "¡La historia es Reina! - Cada proyecto cuenta una historia única que resuena con tu audiencia",
      "¿Nuestro mejor trabajo? …¡El siguiente! - Siempre buscamos superar nuestros límites"
    ],
    "contact": {
      "phone": "+502 4693-3600",
      "email": "reflexmediagt@gmail.com",
      "location": "Ciudad de Guatemala, Guatemala",
      "hours": {
        "weekdays": "Lunes - Viernes: 9:00 AM - 6:00 PM",
        "saturday": "Sábado: 10:00 AM - 2:00 PM",
        "sunday": "Domingo: Cerrado"
      }
    }
  },
  "services": [
    {
      "id": "prototipos",
      "name": "Desarrollo de Prototipos",
      "description": "Convertimos conceptos en prototipos funcionales que demuestran la viabilidad de tu idea y permiten realizar pruebas con usuarios reales.",
      "features": [
        "Prototipado rápido de interfaces",
        "Desarrollo de MVPs",
        "Pruebas de usabilidad",
        "Iteración basada en feedback"
      ],
      "keywords": ["prototipo", "mvp", "diseño", "interfaz", "app"]
    },
    {
      "id": "diseno",
      "name": "Diseño de Proyectos",
      "description": "Creamos experiencias visuales memorables que conectan con tu audiencia y refuerzan la identidad de tu marca.",
      "features": [
        "Diseño UI/UX",
        "Identidad visual",
        "Diseño de interacción",
        "Sistemas de diseño"
      ],
      "keywords": ["diseño", "ui", "ux", "visual", "marca", "identidad"]
    },
    {
      "id": "ia",
      "name": "Inteligencia Artificial",
      "description": "Implementamos tecnologías de inteligencia artificial para optimizar procesos y crear experiencias innovadoras.",
      "features": [
        "Chatbots y asistentes virtuales",
        "Análisis predictivo",
        "Automatización de procesos",
        "Personalización basada en IA"
      ],
      "keywords": ["ia", "inteligencia artificial", "chatbot", "automatización", "ai"]
    },
    {
      "id": "audiovisual",
      "name": "Producción Audiovisual",
      "description": "Producimos contenido audiovisual de alta calidad que cuenta historias impactantes y conecta con tu audiencia.",
      "features": [
        "Producción de videos corporativos",
        "Spots publicitarios",
        "Contenido para redes sociales",
        "Animación y motion graphics"
      ],
      "keywords": ["video", "audiovisual", "producción", "animación", "cortometraje"]
    },
    {
      "id": "marketing",
      "name": "Marketing Digital",
      "description": "Asesoramos estratégicamente para potenciar tu presencia en el mercado y alcanzar tus objetivos de negocio.",
      "features": [
        "Estrategia de marketing digital",
        "Posicionamiento de marca",
        "Análisis de mercado",
        "Optimización de conversión"
      ],
      "keywords": ["marketing", "digital", "estrategia", "redes sociales", "publicidad"]
    }
  ],
  "projects": [
    {
      "name": "DingDong",
      "category": "Prototipos",
      "description": "Diseño de interfaz de usuario para una aplicación de entrega de comida a domicilio.",
      "client": "FoodTech Inc."
    },
    {
      "name": "Guaterflow",
      "category": "Cortometrajes",
      "description": "Cortometraje documental sobre la belleza natural y cultural de Guatemala.",
      "client": "Ministerio de Turismo"
    },
    {
      "name": "EcoSmart",
      "category": "Lanzamientos",
      "description": "Lanzamiento de línea de productos ecológicos para el hogar.",
      "client": "EcoLiving"
    }
  ],
  "faqs": [
    {
      "question": "¿Cuál es el proceso para iniciar un proyecto?",
      "answer": "El proceso comienza con una consulta inicial donde discutimos tus necesidades y objetivos. Luego, desarrollamos una propuesta detallada y, una vez aprobada, comenzamos el trabajo según un cronograma acordado.",
      "keywords": ["proceso", "iniciar", "proyecto", "comenzar", "empezar"]
    },
    {
      "question": "¿Cuánto tiempo toma completar un proyecto?",
      "answer": "El tiempo de desarrollo varía según la complejidad y el alcance del proyecto. Durante la fase de planificación, establecemos un cronograma realista que se adapta a tus necesidades.",
      "keywords": ["tiempo", "duración", "cuánto", "plazo"]
    },
    {
      "question": "¿Trabajan con clientes internacionales?",
      "answer": "Sí, trabajamos con clientes de todo el mundo. Utilizamos herramientas de comunicación digital para mantener una colaboración fluida independientemente de la ubicación geográfica.",
      "keywords": ["internacional", "extranjero", "remoto", "distancia"]
    },
    {
      "question": "¿Qué información necesitan para cotizar?",
      "answer": "Para proporcionar una cotización precisa, necesitamos entender tus objetivos, el alcance del proyecto, el público objetivo, los plazos deseados y cualquier requisito específico que puedas tener.",
      "keywords": ["cotizar", "precio", "costo", "presupuesto", "cotización"]
    },
    {
      "question": "¿Ofrecen soporte post-lanzamiento?",
      "answer": "Sí, ofrecemos soporte continuo después del lanzamiento para asegurar que tu proyecto funcione perfectamente y pueda evolucionar según tus necesidades.",
      "keywords": ["soporte", "mantenimiento", "post-lanzamiento", "después"]
    }
  ],
  "greetings": [
    "¡Hola! Soy ORION, tu asistente virtual de Grupo Reflex. ¿En qué puedo ayudarte hoy?",
    "¡Bienvenido! Estoy aquí para responder tus preguntas sobre nuestros servicios y proyectos.",
    "¡Hola! ¿Tienes alguna pregunta sobre Grupo Reflex? Estoy aquí para ayudarte."
  ],
  "fallback": "Disculpa, no tengo información específica sobre eso. Te recomiendo contactar directamente con nuestro equipo en reflexmediagt@gmail.com o llamar al +502 4693-3600 para obtener una respuesta personalizada."
}